// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
export type ProjectExportProgressMessage = {
  projectId: string;
  progress: number;
};

export type ProjectExportFailedMessage = {
  projectId: string;
  progress?: number;
};

export function isProjectExportProgressMessage(arg): arg is ProjectExportProgressMessage {
  return typeof arg?.projectId === 'string' && typeof arg?.progress === 'number';
}

export function isProjectExportFailedMessage(arg): arg is ProjectExportFailedMessage {
  return typeof arg?.projectId === 'string';
}
